/**
 * Strips runtime-only props from node data and normalizes types for API payload.
 * @throws {Error} e.g. when export node has no name
 */
export function sanitizeRuleElement(element) {
  const { data, ...rest } = element;
  let sanitizedData;

  if (data) {
    sanitizedData = { ...data };
    delete sanitizedData.project;
    delete sanitizedData.save;
    delete sanitizedData.loadProject;
    delete sanitizedData.loadDesigns;
    delete sanitizedData.loadTemplates;
  }

  const sanitizedElement = { ...rest };
  if (sanitizedData !== undefined) {
    sanitizedElement.data = sanitizedData;
  }

  if (
    sanitizedElement.type === 'graphic' &&
    Array.isArray(sanitizedElement.data?.selected)
  ) {
    sanitizedElement.data.selected = sanitizedElement.data.selected.map((item) =>
      Number(item),
    );
  }

  if (sanitizedElement.type === 'export' && sanitizedElement.data) {
    const type = sanitizedElement.data.output_type;
    const numericType = Number(type);
    sanitizedElement.data.output_type =
      numericType === 0 || type === '' ? null : numericType;

    if (!sanitizedElement.data.name) {
      throw new Error('Export name is required');
    }
  }

  return sanitizedElement;
}

export function sanitizeRuleElements(elements) {
  return (elements ?? []).map((el) => sanitizeRuleElement(el));
}

/** Full rule_json object from React Flow `toObject()` output. */
export function buildSanitizedRulePayload(flowState) {
  return {
    ...flowState,
    elements: sanitizeRuleElements(flowState.elements),
  };
}
